module.exports = __webpack_public_path__ + "img/ESG_folyamatabra.7ae78b30.jpg";